module.exports = require("react-dom");


//////////////////
// WEBPACK FOOTER
// external "react-dom"
// module id = 513
// module chunks = 0